export default function queryString(qs?: string): Record<string, string> {
    const query =
        qs === undefined
            ? window.location.search.substring(1)
            : qs.split('?')[1];

    return query.split('&').reduce((acc, q) => {
        const pair = q.split('=');
        return { ...acc, [pair[0]]: pair[1] };
    }, {});
}
